import React from 'react';
import styles from './index.css';
import auth from '../../../../../../base/auth';
import { rel } from '../../../utils/rel';
class CommentTextareaBottom extends React.PureComponent {
    constructor() {
        super(...arguments);
        // 凤凰全站登录,
        this.ifengLogin = () => {
            console.log(this.props.loginId);
            auth.login(this.props.loginId);
        };
        // sina用户登录
        this.sinaLogin = () => {
            const sinaAPI = 'https://api.weibo.com/oauth2/authorize?client_id=1073104718&redirect_uri=http%3A%2F%2Fid.ifeng.com%2Fcallback%2Fsina&response_type=code';
            const logWin_width = '770';
            const logWin_height = '630';
            window.open(sinaAPI, logWin_width, logWin_height);
            auth.login(this.props.loginId);
        };
        // 登出
        this.logOut = () => {
            auth.logout();
        };
    }
    render() {
        const { userInfo, myComUrl } = this.props;
        return (React.createElement("div", { className: styles.comment_textarea_bottom }, userInfo ? (React.createElement(React.Fragment, null,
            React.createElement("span", { className: styles.userinfo }, userInfo.userName),
            React.createElement("span", { className: styles.line }, "/"),
            React.createElement("a", { href: myComUrl, target: "_blank", rel: rel, className: styles.account }, "\u6211\u7684\u8BC4\u8BBA"),
            React.createElement("span", { className: styles.line }, "/"),
            React.createElement("a", { className: styles.account, onClick: this.logOut }, "\u9000\u51FA"))) : (React.createElement(React.Fragment, null,
            React.createElement("span", { className: styles.userinfo }, "\u4E00\u952E\u767B\u5F55\uFF1A "),
            React.createElement("a", { className: styles.account, onClick: this.ifengLogin }, "\u51E4\u51F0\u8D26\u53F7"),
            React.createElement("span", { className: styles.line }, "/"),
            React.createElement("a", { className: styles.account, onClick: this.sinaLogin }, "\u65B0\u6D6A\u5FAE\u535A")))));
    }
}
export default CommentTextareaBottom;
